// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  /* scroll-behavior: smooth; */
}

body {
  margin: 0;
  padding: 0;
  /* font-family: "Rubik", sans-serif; */
  /* font-family: 'Open Sans', sans-serif; */
  /* font-family: 'Cabin', sans-serif; */
  /* font-family: 'Lato', sans-serif; */
  /* font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto; */
  font-family: 'Poppins', sans-serif;
  /* font-family: 'Montserrat', sans-serif; */
  /* background-color: #f0f2f5; */
  background-color: #eaeaea;
}

.swal-text {
  text-align: center !important;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  /* color: darkgray !important; */
  color: #778899 !important;
}

html {
  overflow-x: hidden;
  font-size: 100% !important;
}

.sendgrid-link:hover {
  cursor: pointer;
  color: var(--green);
}

@media only screen and (min-width: 112.5em) {
  html {
    font-size: 100% !important;
  }
}

@media only screen and (max-width: 90em) {
  html {
    font-size: 75% !important;
  }
}

@media only screen and (max-width: 64em) {
  html {
    font-size: 90% !important;
  }
}

@media only screen and (max-width: 48em) {
  html {
    font-size: 80% !important;
  }
}

@media only screen and (max-width: 26.5625em) {
  html {
    font-size: 80% !important;
  }
}

@media only screen and (max-width: 23.4375em) {
  html {
    font-size: 70% !important;
  }
}

@media only screen and (max-width: 20em) {
  html {
    font-size: 60% !important;
  }
}

@media only screen and (max-width: 7.5em) {
  html {
    font-size: 40% !important;
  }
}

/* //1rem = 12, 12/16 */
/* //1800 */
/* //1440px */
/* //1024px */
/* //768px */
/* //425px */
/* //375px */
/* //320px */
.color-white {
  color: var(--white) !important;
}

.color-grey {
  color: var(--grey) !important;
}

.general-header {
  background-color: white;
  /* background-color: white; */
  box-shadow: var(--boxShadow);
  padding: 1.063rem 1.875rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  width: 100%;
  z-index: 100;
  top: 0;
}

@media only screen and (max-width: 36.063rem) {
  .header-temp {
    position: static !important;
  }
}

.switch-drop-container {
  background-color: var(--green) !important;
  border: none !important;
  outline: none !important;
  border-radius: 0.188rem;
  padding: 5px !important;
}

.switch-drop-container .drop-item {
  color: var(--white) !important;
  font-weight: bold;
  letter-spacing: 0.125rem !important;
  padding: 2px 0 !important;
  cursor: pointer !important;
}

.general-header .Buttons .switch-mode-btn {
  /* width: max-content;
  display: flex;
  align-items: center;
  background-color: var(--green) !important;
  color: var(--white) !important;
  border: none !important;
  outline: none !important;
  border-radius: 0.188rem;
  font-weight: bold;
  letter-spacing: 0.125rem;
  padding: 4px 15px;
  text-shadow: 0 -1px 0 rgb(0 0 0 / 12%);
  cursor: pointer;
  min-width: 150px; */
}

.general-header .Buttons {
  display: flex;
  column-gap: 10px;
}

.general-header .Buttons button:nth-child(2) {
  margin: 0 0.625rem;
}

.general-header .Buttons button {
  background-color: white;
  color: var(--primary-color);
}

.general-header .vendor-info {
  display: flex;
  align-items: center;
}

.general-header .vendor-info p {
  margin-bottom: 0;
  margin-left: 0.625rem;
  text-transform: capitalize;
  font-size: 1.063rem;
  font-weight: bold;
}

.general-header h2 {
  /* color: var(--secondary-color); */
  color: black !important;
  margin: 0;
  letter-spacing: 0.125rem;
  font-weight: bold;
}

.graph-card {
  background-color: white;
  padding: 1rem;
  border-radius: 0.75rem;
}

.graph-card .ant-table-thead th {
  font-size: 16px;
}

.graph-card canvas {
  height: 33.125rem !important;
}

.radar-chart canvas {
  height: 54.375rem !important;
}

.graph-card .heading {
  min-height: 12.5rem;
}

.graph-card .desc {
  font-size: 0.875rem;
  display: flex;
  justify-content: center;
  text-align: center;
  margin-top: 0.625rem;
}

.dzu-dropzone .dzu-input {
  display: none !important;
}

/* multi carosel actions */
.react-multiple-carousel__arrow--right {
  right: 0;
}

.react-multiple-carousel__arrow--left {
  left: 0.625rem;
}

.react-multiple-carousel__arrow {
  background-color: white;
  border-radius: 0.313rem;
  min-height: 6.25rem;
  min-width: 3.125rem;
}

.react-multiple-carousel__arrow::before {
  font-size: 1.563rem;
  color: black;
}

.react-multiple-carousel__arrow:hover {
  background-color: white;
}

.flex-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

/* facebook api header css */
textarea {
  border-radius: 0.25rem;
  font-size: 1rem;
  padding: 0.25rem 0.5rem;
}

#app {
  min-height: 100vh;
  background-color: #252526;
  color: #e4e6eb;
}

#app-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0.75rem;
}

#logo-text {
  font-size: 1.25rem;
  font-weight: 500;
}

#app-main {
  max-width: 64rem;
  margin: 0 auto;
  padding: 1.25rem 1.5rem;
}

.card {
  border: none !important;
  margin-top: 18px;
  background-color: white;
  padding: 10px;
  border-radius: 4px;
}

.app-section {
  display: flex;
  flex-direction: column;
}

.app-section:not(:first-child) {
  margin-top: 1.5rem;
}

.btn {
  border-radius: 0.25rem;
  color: #e4e6eb;
  font-size: 1rem;
  font-weight: 600;
  padding: 0.75rem;
  border: none;
}

.btn:not(:disabled):hover {
  filter: brightness(0.9);
}

.confirm-btn {
  margin-top: 0.5;
  background-color: #2d88ff;
}

.placeholder-container {
  display: flex;
  justify-content: center;
}

.secondary-btn {
  width: max-content;
  display: flex;
  align-items: center;
  background-color: var(--green) !important;
  color: var(--white) !important;
  border: none !important;
  outline: none !important;
  border-radius: 0.188rem;
  font-weight: bold;
  letter-spacing: 0.125rem;
  padding: 4px 15px;
  text-shadow: 0 -1px 0 rgb(0 0 0 / 12%);
  cursor: pointer;
}

.navigate-link {
  color: #2d88ff;
  cursor: pointer;
}

.navigate-link:hover {
  color: #076ff7;
}

/* facebook api header css */

/* footer css */
.footer {
  position: absolute;
  top: 90%;
  left: 50%;
  transform: translate(-50%);
  width: 100%;
}

@media only screen and (max-width: 1000px) {
  .general-header .Buttons button {
    margin: 0;
    font-size: 12px;
  }

  .header-btn {
    min-width: 80px !important;
  }
  .switch-mode-btn {
    min-width: 80px !important;
  }
}
@media only screen and (max-width: 760px) {
  .general-header h2 {
    font-size: 24px !important;
    letter-spacing: 0 !important;
    font-weight: 300;
  }
  .general-header {
    padding: 1rem 1rem;
  }
}

/* @media only screen and (max-width: 768px) {
  .header-btn {
    min-width: 100px !important;
    background: red !important;
  }
} */

@media only screen and (max-height: 500px) {
  .footer {
    position: relative;
    top: 0;
  }
}

@media only screen and (max-width: 36.063rem) {
  .footer {
    position: static;
    transform: initial;
    padding: 1rem 1rem;
  }
}

.footer .inner-wrapper {
  max-width: 31.25;
  text-align: center;
  margin: auto;
  display: flex;
  flex-direction: column;
}

/* footer css */

/* email status change btn */

.email-active {
  background-color: transparent !important;
  color: var(--green) !important;
  border: 1px solid var(--green) !important;
}

.email-active:hover {
  background-color: var(--green) !important;
  color: white !important;
}

.email-inactive {
  background-color: transparent !important;
  color: red !important;
  border: 1px solid red !important;
}

.email-inactive:hover {
  background-color: red !important;
  color: white !important;
}

/* email status change btn */

/* side bar drawer scrollbar  */
.HomeDrawer {
  /* width */
  ::-webkit-scrollbar {
    width: 10px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: transparent;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #8888889d;
    border-radius: 15px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/_general.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sCAAsC;EACtC,0CAA0C;EAC1C,sCAAsC;EACtC,qCAAqC;EACrC,mFAAmF;EACnF,kCAAkC;EAClC,2CAA2C;EAC3C,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;;;;;EAME,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,uBAAuB;AACvB,WAAW;AACX,aAAa;AACb,aAAa;AACb,YAAY;AACZ,YAAY;AACZ,YAAY;AACZ,YAAY;AACZ;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,4BAA4B;EAC5B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,WAAW;EACX,YAAY;EACZ,MAAM;AACR;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,yCAAyC;EACzC,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,mCAAmC;EACnC,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE;;;;;;;;;;;;;qBAamB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,uBAAuB;EACvB,SAAS;EACT,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,0BAA0B;AAC1B;EACE,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,sBAAsB;EACtB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,8BAA8B;EAC9B,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;EACvB,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,4BAA4B;;AAE5B,eAAe;AACf;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,0BAA0B;IAC1B,4BAA4B;IAC5B,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;;;;;GAKG;;AAEH;EACE;IACE,kBAAkB;IAClB,MAAM;EACR;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;EACpB;AACF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA,eAAe;;AAEf,4BAA4B;;AAE5B;EACE,wCAAwC;EACxC,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;EACzC,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;EACxC,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA,4BAA4B;;AAE5B,+BAA+B;AAC/B;EACE,UAAU;EACV;IACE,WAAW;EACb;;EAEA,UAAU;EACV;IACE,uBAAuB;EACzB;;EAEA,WAAW;EACX;IACE,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA,oBAAoB;EACpB;IACE,gBAAgB;EAClB;AACF","sourcesContent":["* {\r\n  /* scroll-behavior: smooth; */\r\n}\r\n\r\nbody {\r\n  margin: 0;\r\n  padding: 0;\r\n  /* font-family: \"Rubik\", sans-serif; */\r\n  /* font-family: 'Open Sans', sans-serif; */\r\n  /* font-family: 'Cabin', sans-serif; */\r\n  /* font-family: 'Lato', sans-serif; */\r\n  /* font-family: -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto; */\r\n  font-family: 'Poppins', sans-serif;\r\n  /* font-family: 'Montserrat', sans-serif; */\r\n  /* background-color: #f0f2f5; */\r\n  background-color: #eaeaea;\r\n}\r\n\r\n.swal-text {\r\n  text-align: center !important;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6 {\r\n  /* color: darkgray !important; */\r\n  color: #778899 !important;\r\n}\r\n\r\nhtml {\r\n  overflow-x: hidden;\r\n  font-size: 100% !important;\r\n}\r\n\r\n.sendgrid-link:hover {\r\n  cursor: pointer;\r\n  color: var(--green);\r\n}\r\n\r\n@media only screen and (min-width: 112.5em) {\r\n  html {\r\n    font-size: 100% !important;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 90em) {\r\n  html {\r\n    font-size: 75% !important;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 64em) {\r\n  html {\r\n    font-size: 90% !important;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 48em) {\r\n  html {\r\n    font-size: 80% !important;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 26.5625em) {\r\n  html {\r\n    font-size: 80% !important;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 23.4375em) {\r\n  html {\r\n    font-size: 70% !important;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 20em) {\r\n  html {\r\n    font-size: 60% !important;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 7.5em) {\r\n  html {\r\n    font-size: 40% !important;\r\n  }\r\n}\r\n\r\n/* //1rem = 12, 12/16 */\r\n/* //1800 */\r\n/* //1440px */\r\n/* //1024px */\r\n/* //768px */\r\n/* //425px */\r\n/* //375px */\r\n/* //320px */\r\n.color-white {\r\n  color: var(--white) !important;\r\n}\r\n\r\n.color-grey {\r\n  color: var(--grey) !important;\r\n}\r\n\r\n.general-header {\r\n  background-color: white;\r\n  /* background-color: white; */\r\n  box-shadow: var(--boxShadow);\r\n  padding: 1.063rem 1.875rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  position: fixed;\r\n  width: 100%;\r\n  z-index: 100;\r\n  top: 0;\r\n}\r\n\r\n@media only screen and (max-width: 36.063rem) {\r\n  .header-temp {\r\n    position: static !important;\r\n  }\r\n}\r\n\r\n.switch-drop-container {\r\n  background-color: var(--green) !important;\r\n  border: none !important;\r\n  outline: none !important;\r\n  border-radius: 0.188rem;\r\n  padding: 5px !important;\r\n}\r\n\r\n.switch-drop-container .drop-item {\r\n  color: var(--white) !important;\r\n  font-weight: bold;\r\n  letter-spacing: 0.125rem !important;\r\n  padding: 2px 0 !important;\r\n  cursor: pointer !important;\r\n}\r\n\r\n.general-header .Buttons .switch-mode-btn {\r\n  /* width: max-content;\r\n  display: flex;\r\n  align-items: center;\r\n  background-color: var(--green) !important;\r\n  color: var(--white) !important;\r\n  border: none !important;\r\n  outline: none !important;\r\n  border-radius: 0.188rem;\r\n  font-weight: bold;\r\n  letter-spacing: 0.125rem;\r\n  padding: 4px 15px;\r\n  text-shadow: 0 -1px 0 rgb(0 0 0 / 12%);\r\n  cursor: pointer;\r\n  min-width: 150px; */\r\n}\r\n\r\n.general-header .Buttons {\r\n  display: flex;\r\n  column-gap: 10px;\r\n}\r\n\r\n.general-header .Buttons button:nth-child(2) {\r\n  margin: 0 0.625rem;\r\n}\r\n\r\n.general-header .Buttons button {\r\n  background-color: white;\r\n  color: var(--primary-color);\r\n}\r\n\r\n.general-header .vendor-info {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.general-header .vendor-info p {\r\n  margin-bottom: 0;\r\n  margin-left: 0.625rem;\r\n  text-transform: capitalize;\r\n  font-size: 1.063rem;\r\n  font-weight: bold;\r\n}\r\n\r\n.general-header h2 {\r\n  /* color: var(--secondary-color); */\r\n  color: black !important;\r\n  margin: 0;\r\n  letter-spacing: 0.125rem;\r\n  font-weight: bold;\r\n}\r\n\r\n.graph-card {\r\n  background-color: white;\r\n  padding: 1rem;\r\n  border-radius: 0.75rem;\r\n}\r\n\r\n.graph-card .ant-table-thead th {\r\n  font-size: 16px;\r\n}\r\n\r\n.graph-card canvas {\r\n  height: 33.125rem !important;\r\n}\r\n\r\n.radar-chart canvas {\r\n  height: 54.375rem !important;\r\n}\r\n\r\n.graph-card .heading {\r\n  min-height: 12.5rem;\r\n}\r\n\r\n.graph-card .desc {\r\n  font-size: 0.875rem;\r\n  display: flex;\r\n  justify-content: center;\r\n  text-align: center;\r\n  margin-top: 0.625rem;\r\n}\r\n\r\n.dzu-dropzone .dzu-input {\r\n  display: none !important;\r\n}\r\n\r\n/* multi carosel actions */\r\n.react-multiple-carousel__arrow--right {\r\n  right: 0;\r\n}\r\n\r\n.react-multiple-carousel__arrow--left {\r\n  left: 0.625rem;\r\n}\r\n\r\n.react-multiple-carousel__arrow {\r\n  background-color: white;\r\n  border-radius: 0.313rem;\r\n  min-height: 6.25rem;\r\n  min-width: 3.125rem;\r\n}\r\n\r\n.react-multiple-carousel__arrow::before {\r\n  font-size: 1.563rem;\r\n  color: black;\r\n}\r\n\r\n.react-multiple-carousel__arrow:hover {\r\n  background-color: white;\r\n}\r\n\r\n.flex-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n/* facebook api header css */\r\ntextarea {\r\n  border-radius: 0.25rem;\r\n  font-size: 1rem;\r\n  padding: 0.25rem 0.5rem;\r\n}\r\n\r\n#app {\r\n  min-height: 100vh;\r\n  background-color: #252526;\r\n  color: #e4e6eb;\r\n}\r\n\r\n#app-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 0 0.75rem;\r\n}\r\n\r\n#logo-text {\r\n  font-size: 1.25rem;\r\n  font-weight: 500;\r\n}\r\n\r\n#app-main {\r\n  max-width: 64rem;\r\n  margin: 0 auto;\r\n  padding: 1.25rem 1.5rem;\r\n}\r\n\r\n.card {\r\n  border: none !important;\r\n  margin-top: 18px;\r\n  background-color: white;\r\n  padding: 10px;\r\n  border-radius: 4px;\r\n}\r\n\r\n.app-section {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.app-section:not(:first-child) {\r\n  margin-top: 1.5rem;\r\n}\r\n\r\n.btn {\r\n  border-radius: 0.25rem;\r\n  color: #e4e6eb;\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  padding: 0.75rem;\r\n  border: none;\r\n}\r\n\r\n.btn:not(:disabled):hover {\r\n  filter: brightness(0.9);\r\n}\r\n\r\n.confirm-btn {\r\n  margin-top: 0.5;\r\n  background-color: #2d88ff;\r\n}\r\n\r\n.placeholder-container {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.secondary-btn {\r\n  width: max-content;\r\n  display: flex;\r\n  align-items: center;\r\n  background-color: var(--green) !important;\r\n  color: var(--white) !important;\r\n  border: none !important;\r\n  outline: none !important;\r\n  border-radius: 0.188rem;\r\n  font-weight: bold;\r\n  letter-spacing: 0.125rem;\r\n  padding: 4px 15px;\r\n  text-shadow: 0 -1px 0 rgb(0 0 0 / 12%);\r\n  cursor: pointer;\r\n}\r\n\r\n.navigate-link {\r\n  color: #2d88ff;\r\n  cursor: pointer;\r\n}\r\n\r\n.navigate-link:hover {\r\n  color: #076ff7;\r\n}\r\n\r\n/* facebook api header css */\r\n\r\n/* footer css */\r\n.footer {\r\n  position: absolute;\r\n  top: 90%;\r\n  left: 50%;\r\n  transform: translate(-50%);\r\n  width: 100%;\r\n}\r\n\r\n@media only screen and (max-width: 1000px) {\r\n  .general-header .Buttons button {\r\n    margin: 0;\r\n    font-size: 12px;\r\n  }\r\n\r\n  .header-btn {\r\n    min-width: 80px !important;\r\n  }\r\n  .switch-mode-btn {\r\n    min-width: 80px !important;\r\n  }\r\n}\r\n@media only screen and (max-width: 760px) {\r\n  .general-header h2 {\r\n    font-size: 24px !important;\r\n    letter-spacing: 0 !important;\r\n    font-weight: 300;\r\n  }\r\n  .general-header {\r\n    padding: 1rem 1rem;\r\n  }\r\n}\r\n\r\n/* @media only screen and (max-width: 768px) {\r\n  .header-btn {\r\n    min-width: 100px !important;\r\n    background: red !important;\r\n  }\r\n} */\r\n\r\n@media only screen and (max-height: 500px) {\r\n  .footer {\r\n    position: relative;\r\n    top: 0;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 36.063rem) {\r\n  .footer {\r\n    position: static;\r\n    transform: initial;\r\n    padding: 1rem 1rem;\r\n  }\r\n}\r\n\r\n.footer .inner-wrapper {\r\n  max-width: 31.25;\r\n  text-align: center;\r\n  margin: auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n/* footer css */\r\n\r\n/* email status change btn */\r\n\r\n.email-active {\r\n  background-color: transparent !important;\r\n  color: var(--green) !important;\r\n  border: 1px solid var(--green) !important;\r\n}\r\n\r\n.email-active:hover {\r\n  background-color: var(--green) !important;\r\n  color: white !important;\r\n}\r\n\r\n.email-inactive {\r\n  background-color: transparent !important;\r\n  color: red !important;\r\n  border: 1px solid red !important;\r\n}\r\n\r\n.email-inactive:hover {\r\n  background-color: red !important;\r\n  color: white !important;\r\n}\r\n\r\n/* email status change btn */\r\n\r\n/* side bar drawer scrollbar  */\r\n.HomeDrawer {\r\n  /* width */\r\n  ::-webkit-scrollbar {\r\n    width: 10px;\r\n  }\r\n\r\n  /* Track */\r\n  ::-webkit-scrollbar-track {\r\n    background: transparent;\r\n  }\r\n\r\n  /* Handle */\r\n  ::-webkit-scrollbar-thumb {\r\n    background: #8888889d;\r\n    border-radius: 15px;\r\n  }\r\n\r\n  /* Handle on hover */\r\n  ::-webkit-scrollbar-thumb:hover {\r\n    background: #555;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
